import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  signal,
} from '@angular/core';
import { SoftwareUpdate } from '../models/software-update.model';
import { DatePipe } from '@angular/common';
import { Modal } from '../../../shared/components/modal/modal';

@Component({
  selector: 'app-software-update-detail-dialog',
  imports: [DatePipe, Modal],
  templateUrl: './detail-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SoftwareUpdateDetailDialogComponent {
  @Input({ required: true }) update!: SoftwareUpdate;
  @Output() close = new EventEmitter<void>();

  readonly open = signal(true);

  formatSize(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1048576).toFixed(1)} MB`;
  }

  onClose() {
    this.close.emit();
  }
}
